import React, { useEffect, useState } from 'react';
import { Modal, message, Icon } from 'antd';
import { ClipLoader } from 'react-spinners';
import moment from 'moment';
import { getDevices, deleteDevice } from '../../Actions/Member';
import './ManageDeviceModal.scss';

const ManageDeviceModal = props => {
   const { visible, onClose } = props;
   const [devices, setDevices] = useState([]);
   const [loading, setLoading] = useState(false);
   const [deletingUID, setDeletingUID] = useState(null);

   useEffect(() => {
      if (visible) {
         loadDevices();
      } else {
         setDevices([]);
      }
   }, [visible]);

   // keep the current device pinned to the top of the list
   const sortCurrentFirst = list =>
      [...(list || [])].sort((a, b) => (b.isCurrentDevice ? 1 : 0) - (a.isCurrentDevice ? 1 : 0));

   const loadDevices = async () => {
      try {
         setLoading(true);
         const result = await getDevices();
         if (result.status && result.data) {
            setDevices(sortCurrentFirst(result.data.devices));
         }
      } catch (error) {
         message.error('ไม่สามารถโหลดรายการอุปกรณ์ได้ กรุณาลองใหม่อีกครั้ง');
      } finally {
         setLoading(false);
      }
   };

   const handleRemoveDevice = async device => {
      try {
         setDeletingUID(device.deviceuid);
         const result = await deleteDevice(device.deviceuid);
         if (result.status && result.data) {
            setDevices(sortCurrentFirst(result.data.devices));
            message.success('ลบอุปกรณ์เรียบร้อยแล้ว');
         }
      } catch (error) {
         message.error('ไม่สามารถลบอุปกรณ์ได้ กรุณาลองใหม่อีกครั้ง');
      } finally {
         setDeletingUID(null);
      }
   };

   const confirmRemoveDevice = device => {
      Modal.confirm({
         className: 'manage-device-confirm',
         title: 'ยืนยันการลบอุปกรณ์',
         content: `ต้องการลบอุปกรณ์ ${device.devicename || device.devicemodel || 'นี้'} หรือไม่`,
         okText: 'ลบอุปกรณ์',
         cancelText: 'ยกเลิก',
         okType: 'danger',
         onOk: () => handleRemoveDevice(device),
      });
   };

   const renderDevice = device => {
      const isDeleting = deletingUID === device.deviceuid;
      const lastActive = device.regisDate
         ? moment.unix(device.regisDate).format('D MMM YYYY HH:mm น.')
         : '-';

      return (
         <div className="manage-device-item" key={device.deviceuid}>
            <div className="manage-device-info">
               <div className="manage-device-name">
                  {device.devicename || device.devicemodel || 'ไม่ทราบชื่ออุปกรณ์'}
                  {device.isCurrentDevice && <span className="manage-device-current">เครื่องนี้</span>}
               </div>
               <div className="manage-device-detail">
                  {[device.devicemodel, `${device.os || ''} ${device.osversion || ''}`.trim()]
                     .filter(Boolean)
                     .join(' • ')}
               </div>
               <div className="manage-device-detail">ใช้งานล่าสุด: {lastActive}</div>
            </div>
            <div className="manage-device-action">
               {device.isCurrentDevice ? null : isDeleting ? (
                  <ClipLoader size={20} color={'#123abc'} loading={true} />
               ) : (
                  <Icon
                     type="delete"
                     className="manage-device-delete"
                     onClick={() => confirmRemoveDevice(device)}
                  />
               )}
            </div>
         </div>
      );
   };

   return (
      <Modal
         visible={visible}
         className="manageDeviceModal"
         title="จัดการอุปกรณ์"
         footer={null}
         onCancel={onClose}
      >
         {loading ? (
            <div className="manage-device-loading">
               <ClipLoader size={40} color={'#123abc'} loading={true} />
            </div>
         ) : devices.length === 0 ? (
            <div className="manage-device-empty">ไม่พบอุปกรณ์</div>
         ) : (
            <div className="manage-device-list">{devices.map(renderDevice)}</div>
         )}
      </Modal>
   );
};

export default ManageDeviceModal;
